module.exports = new __parcel__URL__("Icon-star.a3f2bf92.svg").toString();